import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FiltersIcon from "../../images/icons/FiltersIcon.svg";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { FiltersMenuStyle, FiltersMenuXSStyle } from "../../Theme";
import { EPAFiltersOptions } from "../Content";

type IconType = () => JSX.Element;
export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}
export interface DialogContentProps {
  title?: string;
  children?: any;
  windowsize?: any;
  icon?: IconType;
  show?: any;
  close?: any;
  mxvalue?: any;
  handleChange?: any;
  setMXValue?: any;
  showMenu?: any;
  handleShowMenuClick?: any;
}

export const EPAFilters: React.FC<DialogContentProps> = ({
  mxvalue,
  handleChange,
}) => {
  const [anchorElEPA, setAnchorElEPA] = React.useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorElEPA);

  const handleEPAClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElEPA(event.currentTarget);
  };
  const handleEPAClose = () => {
    setAnchorElEPA(null);
  };
  return (
    <>
      <FiltersMenuStyle>
        <IconButton onClick={handleEPAClick}>
          <img src={FiltersIcon} alt="Filter" />
        </IconButton>
        <Typography variant="body2" component={"div"}>
          Rx Type
        </Typography>
      </FiltersMenuStyle>
      <FiltersMenuXSStyle
        anchorEl={anchorElEPA}
        open={open}
        onClose={handleEPAClose}
        onClick={handleEPAClose}
        PaperProps={{
          elevation: 0,
          className: "menu",
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <RadioGroup value={mxvalue} onChange={handleChange}>
          {EPAFiltersOptions.map(({ text, value }, index) => {
            return (
              <FormControlLabel
                key={index}
                className={mxvalue === value ? "active" : ""}
                value={value}
                control={<Radio />}
                label={text}
              />
            );
          })}
        </RadioGroup>{" "}
      </FiltersMenuXSStyle>
    </>
  );
};
